module.exports = __webpack_public_path__ + "img/370.a684ba4b.png";